import type * as zod from 'zod';

import type { StepPlayArguments } from '../Step';
import Step from '../Step';

import Arguments from './Arguments';
import Variables from './Variables';

type Arguments = zod.infer<typeof Arguments>;

type Variables = zod.infer<typeof Variables>;

/**
 * Else step executes its substeps if all previous If/ElseIf conditions were false.
 * It has no condition - it simply runs when reached.
 *
 * The block coordination (skipping when previous condition was true) is handled
 * by RoutineRunner.playSteps using instanceof checks.
 */
export default class ElseStep extends Step<Arguments, Variables> {
  public static areSubstepsRequired = true;

  public static Arguments = Arguments;

  public static Variables = Variables;

  public substeps: Array<Step<object, object>> = [];

  public initializeVariableState(): void {
    this.variables = {};
  }

  public async _play({ playSubSteps }: StepPlayArguments): Promise<void> {
    // No condition to evaluate - Else always runs if we reach this point.
    // The RoutineRunner skips this step if a previous condition was satisfied.

    if (await super.shouldStopPlaying()) {
      return;
    }

    await playSubSteps();
  }
}
